import WorkersWidget from './WorkersWidget';

export default WorkersWidget;
